import { useState, useEffect } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

const API_KEY = "AIzaSyDDv9FFGFzMbPDsaPgRF8rIh5RP12uB98I";
const CALENDAR_ID =
  "1325b8c6067825f0531ccfe2635bb3d0fdd717e82fae00312289e78f06e5e7b0@group.calendar.google.com";

export default function YearViewCalendar({ currentYear, setCurrentDate }) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, [currentYear]);

  const fetchEvents = async () => {
    const timeMin = dayjs(`${currentYear.year()}-01-01`).startOf("year").toISOString();
    const timeMax = dayjs(`${currentYear.year()}-12-31`).endOf("year").toISOString();

    const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(
      CALENDAR_ID
    )}/events?key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&singleEvents=true&orderBy=startTime`;

    try {
      const response = await axios.get(url);
      setEvents(response.data.items);
    } catch (error) {
      console.error("Erreur lors du chargement des événements", error);
    }
  };

  const hasEvent = (date) => {
    return events.some((event) =>
      dayjs(event.start.dateTime || event.start.date).isSame(date, "day")
    );
  };

  const renderMonth = (monthIndex) => {
    const monthStart = dayjs(new Date(currentYear.year(), monthIndex));
    const startDay = monthStart.startOf("month").day();
    const daysInMonth = monthStart.daysInMonth();

    const days = [];
    for (let i = 0; i < startDay; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(i);

    return (
      <div key={monthIndex} className="rounded-lg p-4 bg-white shadow border">
        <h3 className="text-center font-semibold text-gray-800 mb-3 text-base">
          {monthStart.format("MMMM")}
        </h3>

        <div className="grid grid-cols-7 text-xs text-gray-500 font-medium text-center mb-2">
          {["M", "T", "W", "T", "F", "S", "S"].map((d) => (
            <div key={d}>{d}</div>
          ))}
        </div>
        <div className="grid grid-cols-7 text-xs gap-y-1 text-center">
          {days.map((day, idx) => {
            const date = day
              ? dayjs(new Date(currentYear.year(), monthIndex, day))
              : null;

            const isToday = date && date.isSame(dayjs(), "day");
            const isEvent = date && hasEvent(date);

            return (
              <div key={idx} className="h-9 flex justify-center items-center">
                {day ? (
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center transition
                      ${
                        isToday
                          ? "bg-violet-600 text-white font-semibold"
                          : isEvent
                          ? "bg-violet-100 text-violet-800 font-medium"
                          : "text-gray-800 hover:bg-gray-100"
                      }`}
                  >
                    {day}
                  </div>
                ) : (
                  <div className="w-8 h-8" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full bg-white shadow-md rounded-lg p-4">
      {/* Wrapper scrollable */}
      <div className="max-h-[680px] overflow-y-auto pr-2">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentYear.year()}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6"
          >
            {Array.from({ length: 12 }).map((_, idx) => renderMonth(idx))}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Légende */}
      <div className="mt-6 flex justify-center gap-6 text-sm text-gray-500">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 bg-violet-600 rounded-full inline-block"></span>
          Aujourd’hui
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 bg-violet-100 rounded-full inline-block"></span>
          Événement
        </div>
      </div>
    </div>
  );
}